import React from "react";
import { AppBar, Toolbar, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

function MobileTopBar({ onMenuClick }) {
  return (
    <AppBar
      position="static"
      elevation={0}
      color="inherit"
      sx={{
        display: { xs: "flex", md: "none" },
        borderBottom: "1px solid #e5e7eb",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Toolbar
        sx={{
          display: "grid",
          gridTemplateColumns: "48px 1fr 48px",
          alignItems: "center",
          minHeight: 56,
        }}
      >
        <IconButton
          edge="start"
          onClick={onMenuClick}
          aria-label="Open navigation menu"
          sx={{ color: "#1a1a1a", justifySelf: "start" }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/Sibolab_Logo_darkblue_rgb.png"
            alt="Sibolab"
            style={{ height: "22px", width: "auto" }}
          />
        </Box>

        <Box aria-hidden />
      </Toolbar>
    </AppBar>
  );
}

export default MobileTopBar;
